import { GetProjectResponse } from "api/generatedApi";

export enum Role {
  Participant, // akkorddeltager
  Owner, // akkordejer
  AssistantOwner, //ass. akkordejer
  Manager, // akkordholder
  Inactive, // tidligere deltager
}

export const useRoleRestriction = (project: GetProjectResponse) => {
  const hasRole = (roles: Role[]): boolean => {
    if (project.currentUserRole === "ProjectOwner" && roles.includes(Role.Owner)) {
      return true;
    }

    if (project.currentUserRole === "ProjectAssistantOwner" && roles.includes(Role.AssistantOwner)) {
      return true;
    }

    if (project.currentUserRole === "ProjectParticipant" && roles.includes(Role.Participant)) {
      return true;
    }

    if (project.currentUserRole === "ProjectManager" && roles.includes(Role.Manager)) {
      return true;
    }

    if (project.currentUserRole === "ProjectInactiveParticipant" && roles.includes(Role.Inactive)) {
      return true;
    }

    return false;
  };

  return { hasRole };
};
